import classNames from "classnames";
import * as React from "react";
import { CampaignFilterInfoText } from "../Campaign/CampaignFilterInfoText";
import { DreamFilterButtons } from "../DreamFilterButtons/DreamFilterButtons";
import { DreamAdditionalFilters } from "../DreamFilterButtons/Additional/DreamAdditionalFilters";
import Dreams from "../Dreams";
import { DreamsFloatingTools } from "../DreamsFloatingTools/DreamsFloatingTools";
import { ExclusionLinks } from "../Exclusion/ExclusionLinks";
import { HashTagOptionsChevronPanel } from "../HashTagOptions/HashTagOptionsChevronPanel";
import { DreamHashTagsChevronPanel } from "../HashTags/DreamHashTagsChevronPanel";
import { DreamNameExpansionProvider } from "../NameExpansion/DreamNameExpansionContext";
import { WhenNoSearchResults } from "../Search/NoResults/WhenNoSearchResults";
import { SearchDreams } from "../Search/SearchDreams";
import { NewDreamLinks } from "../Add/NewDreamLinks";
import { DreamsList } from "../DreamsList/DreamsList";
import { DreamTools } from "../DreamTools/DreamTools";
import { EnergyFilterInfoText } from "../Energy/EnergyFilterInfoText";
import { EssayLink } from "../EssayLink";
import { NoDreamsZenIcon } from "../ZenIcon/NoDreamsZenIcon";
import { sharedStylesOld } from "../../../Shared/Styles/SharedStyles";
import * as styles from "../Dreams.css";

export function DreamsView({ dreams }: { dreams: Dreams }) {
    const state = dreams.state;
    const resultsTransitionKey = [
        state.onlyShowTodaysDreams,
        state.onlyShowAdjacentDreams,
        state.searchText,
        state.selectedAttributes.join(","),
        state.filteredData
            .map((dream) => dream.id)
            .sort()
            .join(","),
    ].join("|");

    return (
        <DreamNameExpansionProvider>
            <div
                id="pnlDreams"
                className={classNames(
                    sharedStylesOld.marginBottom1em,
                    sharedStylesOld.marginTopHalfem,
                    styles.centerText
                )}
            >
                <WhenNoSearchResults
                    searchText={state.searchText}
                    filteredData={state.filteredData}
                    style={styles.searchError}
                />
                <SearchDreams dreams={dreams} />
                <DreamFilterButtons dreams={dreams} />
                <EssayLink dreams={dreams} />
                <CampaignFilterInfoText
                    selectedCampaignId={state.selectedCampaignId}
                    allDreams={state.dreamsdata}
                />
                <EnergyFilterInfoText state={state} />
                <DreamResults
                    key={resultsTransitionKey}
                >
                    <DreamsList state={state} />
                    <NoDreamsZenIcon dreams={dreams} />
                </DreamResults>
                <NewDreamLinks dreamsState={state} />
                <ExclusionLinks dreams={dreams} />
                <HashTagOptionsChevronPanel />
                <DreamTools state={state} setState={dreams.setState.bind(dreams)} />
                <DreamAdditionalFilters dreams={dreams} />
                <DreamHashTagsChevronPanel />
                <DreamsFloatingTools />
            </div>
        </DreamNameExpansionProvider>
    );
}

function DreamResults({ children }: { children: React.ReactNode }) {
    const [isVisible, setIsVisible] = React.useState(false);

    React.useEffect(() => {
        let secondFrame = 0;
        const firstFrame = requestAnimationFrame(() => {
            secondFrame = requestAnimationFrame(() => setIsVisible(true));
        });

        return () => {
            cancelAnimationFrame(firstFrame);
            cancelAnimationFrame(secondFrame);
        };
    }, []);

    return (
        <div
            className={classNames(styles.resultsTransition, {
                [styles.resultsTransitionVisible]: isVisible,
            })}
        >
            {children}
        </div>
    );
}
